class RedirectModal extends window.BAOv2.CustomElement {
  static get requiredElements () {
    return ['markets', 'button']
  }

  connectedCallback () {
    super.connectedCallback()
    this.dialog = this.querySelector('dialog')
    this.init()
  }

  init () {
    if (!this.els.markets.exists || !this.els.button.exists) return

    this.fetchCountry()
  }

  fetchCountry () {
    fetch('https://api.ipgeolocation.io/ipgeo?apiKey=d7c83eb0d2dd40f791ccb65bab1768af')
      .then(response => response.json())
      .then(data => {
        const countryCode = data.country_code2
        if (!countryCode) return
        this.initModal(countryCode)
      })
      .catch(error => {
        console.error('Failed to fetch geolocation data:', error)
      })
  }

  initModal (countryCode) {
    const targetHost = this._getTargetHost(countryCode)
    if (!targetHost) return

    const currentHost = window.location.host.toLowerCase()
    if (currentHost === targetHost) return

    this._setLink(targetHost)

    if (!window.sessionStorage.getItem('redirect_modal_shown')) {
      window.sessionStorage.setItem('redirect_modal_shown', '1')
      this.open()
    }
  }

  setupListeners () {
    super.setupListeners()
  }

  open () {
    this.dialog.showModal()
  }

  _setLink (targetHost) {
    const url = `${window.location.protocol}//${targetHost}${window.location.pathname}${window.location.search}${window.location.hash}`
    this.els.button.element.setAttribute('href', url)
  }

  _getTargetHost (countryCode) {
    if (!this.els.markets.exists) return null

    const markets = JSON.parse(this.els.markets.element.textContent)
    return markets[countryCode] || null
  }
}

if (!customElements.get('redirect-modal')) {
  customElements.define('redirect-modal', RedirectModal)
}
